<template>
  <div
    :class="[
      'flex items-center gap-1 border rounded-full px-1  text-xs',
      memberRarityMap[userStore.getMemberType],
    ]"
  >
    {{ $t(`User.forFree.${userStore.getMemberType}`) }}
  </div>
</template>

<script setup lang="ts">
import { useGlobalUser } from "@/stores/globalUser";
import { memberRarityMap } from "@/types/user";

const userStore = useGlobalUser();
</script>
